/**
 * @generated SignedSource<<d6f3b854b2f2ccc7eff0a8b708a973cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditMemberGroupInput = {
  addLeadUserIds?: ReadonlyArray<string> | null;
  addUsers?: ReadonlyArray<string> | null;
  assetId?: string | null;
  color?: string | null;
  description?: string | null;
  id: string;
  name?: string | null;
  removeLeadUserIds?: ReadonlyArray<string> | null;
  removeUsers?: ReadonlyArray<string> | null;
};
export type EditMemberGroupFormMutation$variables = {
  input: EditMemberGroupInput;
};
export type EditMemberGroupFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly memberGroupMemberships: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly memberGroup: {
              readonly " $fragmentSpreads": FragmentRefs<"MemberGroupTagFragment">;
            };
            readonly organizationMembership: {
              readonly " $fragmentSpreads": FragmentRefs<"useMemberGroupTagsList_OrganizationMembershipFragment">;
            };
            readonly productMembership: {
              readonly " $fragmentSpreads": FragmentRefs<"useMemberGroupTagsList_ProductMembershipFragment">;
            } | null;
          };
        }>;
      };
      readonly parentMemberGroup: {
        readonly " $fragmentSpreads": FragmentRefs<"AdminGroupsListRowFragment" | "MemberGroupSubGroupListFragment">;
      } | null;
      readonly product: {
        readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsGroupsTabFragment">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"AdminGroupsListRowFragment" | "GroupsListChildGroupRowFragment">;
    } | null;
  };
};
export type EditMemberGroupFormMutation = {
  response: EditMemberGroupFormMutation$data;
  variables: EditMemberGroupFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "AdminGroupsListRowFragment"
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystem",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarURL",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroupMembershipNodeConnection",
  "kind": "LinkedField",
  "name": "unassignedMembers",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentMemberGroupId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroup",
  "kind": "LinkedField",
  "name": "parentMemberGroup",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "filters": ([]/*: any*/),
  "handle": "connection",
  "key": "AdminGroupsListRow__childrenGroups",
  "kind": "LinkedHandle",
  "name": "childrenGroups"
},
v27 = {
  "alias": "sampleMemberships",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 3
    }
  ],
  "concreteType": "MemberGroupMembershipNodeConnection",
  "kind": "LinkedField",
  "name": "memberGroupMemberships",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberGroupMembershipNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberGroupMembership",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "avatar",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isTest",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "memberGroupMemberships(first:3)"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v31 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v28/*: any*/),
  (v30/*: any*/)
],
v32 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v28/*: any*/),
  (v30/*: any*/)
],
v33 = [
  {
    "kind": "Literal",
    "name": "groupKinds",
    "value": [
      "custom"
    ]
  }
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/)
  ],
  "storageKey": null
},
v35 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberGroupMembershipNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberGroupMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberGroup",
            "kind": "LinkedField",
            "name": "memberGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v21/*: any*/),
              (v20/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/),
              (v18/*: any*/),
              (v8/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      },
      (v23/*: any*/)
    ],
    "storageKey": null
  },
  (v34/*: any*/)
],
v36 = [
  "groupKinds"
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMemberGroupFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditMemberGroupResponse",
        "kind": "LinkedField",
        "name": "editMemberGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroup",
                "kind": "LinkedField",
                "name": "parentMemberGroup",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MemberGroupSubGroupListFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ExperienceSettingsGroupsTabFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupMembershipNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroupMemberships",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupMembershipNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupMembership",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroup",
                            "kind": "LinkedField",
                            "name": "memberGroup",
                            "plural": false,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "MemberGroupTagFragment"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductMembership",
                            "kind": "LinkedField",
                            "name": "productMembership",
                            "plural": false,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "useMemberGroupTagsList_ProductMembershipFragment"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationMembership",
                            "kind": "LinkedField",
                            "name": "organizationMembership",
                            "plural": false,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "useMemberGroupTagsList_OrganizationMembershipFragment"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GroupsListChildGroupRowFragment"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMemberGroupFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "EditMemberGroupResponse",
        "kind": "LinkedField",
        "name": "editMemberGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroup",
                "kind": "LinkedField",
                "name": "parentMemberGroup",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeConnection",
                    "kind": "LinkedField",
                    "name": "childrenGroups",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/),
                              (v5/*: any*/),
                              (v10/*: any*/),
                              (v21/*: any*/),
                              (v6/*: any*/),
                              (v18/*: any*/),
                              (v8/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroupMembershipNodeConnection",
                                "kind": "LinkedField",
                                "name": "memberGroupMemberships",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberGroupMembershipNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MemberGroupMembership",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "userId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "organizationMembershipId",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfoObjectType",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__id",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": [],
                    "handle": "connection",
                    "key": "MemberGroupSubGroupList__childrenGroups",
                    "kind": "LinkedHandle",
                    "name": "childrenGroups"
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroup",
                    "kind": "LinkedField",
                    "name": "defaultMemberGroup",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "kind",
                        "value": "custom"
                      }
                    ],
                    "concreteType": "MemberGroupNodeConnection",
                    "kind": "LinkedField",
                    "name": "memberGroups",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v27/*: any*/),
                              (v7/*: any*/),
                              (v10/*: any*/),
                              (v21/*: any*/),
                              (v18/*: any*/),
                              (v8/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberGroups(kind:\"custom\")"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "Organization",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "nonNullProductId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          (v28/*: any*/),
                          (v30/*: any*/)
                        ],
                        "type": "Product",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v31/*: any*/),
                        "type": "Event",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v32/*: any*/),
                        "type": "Comment",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v32/*: any*/),
                        "type": "Feed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v32/*: any*/),
                        "type": "Post",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "nullableProductIdString",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productId",
                            "storageKey": null
                          },
                          (v28/*: any*/),
                          (v30/*: any*/)
                        ],
                        "type": "ContentUsage",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v32/*: any*/),
                        "type": "ChatChannel",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v32/*: any*/),
                        "type": "Dashboard",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v31/*: any*/),
                        "type": "AssignmentSubmission",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "PathwayGroup",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "BrainSearch",
                        "abstractKey": null
                      }
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupMembershipNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroupMemberships",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupMembershipNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupMembership",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroup",
                            "kind": "LinkedField",
                            "name": "memberGroup",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v7/*: any*/),
                              (v6/*: any*/),
                              (v18/*: any*/),
                              (v8/*: any*/),
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductMembership",
                            "kind": "LinkedField",
                            "name": "productMembership",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": (v33/*: any*/),
                                "concreteType": "MemberGroupMembershipNodeConnection",
                                "kind": "LinkedField",
                                "name": "memberGroupMemberships",
                                "plural": false,
                                "selections": (v35/*: any*/),
                                "storageKey": "memberGroupMemberships(groupKinds:[\"custom\"])"
                              },
                              {
                                "alias": null,
                                "args": (v33/*: any*/),
                                "filters": (v36/*: any*/),
                                "handle": "connection",
                                "key": "useMemberGroupTagsList_ProductMembershipFragment_memberGroupMemberships",
                                "kind": "LinkedHandle",
                                "name": "memberGroupMemberships"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationMembership",
                            "kind": "LinkedField",
                            "name": "organizationMembership",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": (v33/*: any*/),
                                "concreteType": "MemberGroupMembershipNodeConnection",
                                "kind": "LinkedField",
                                "name": "groupMemberships",
                                "plural": false,
                                "selections": (v35/*: any*/),
                                "storageKey": "groupMemberships(groupKinds:[\"custom\"])"
                              },
                              {
                                "alias": null,
                                "args": (v33/*: any*/),
                                "filters": (v36/*: any*/),
                                "handle": "connection",
                                "key": "useMemberGroupTagsList_OrganizationMembershipFragment_groupMemberships",
                                "kind": "LinkedHandle",
                                "name": "groupMemberships"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              (v10/*: any*/),
              (v21/*: any*/),
              (v6/*: any*/),
              (v18/*: any*/),
              (v8/*: any*/),
              (v20/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "childrenGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v21/*: any*/),
                          (v6/*: any*/),
                          (v18/*: any*/),
                          (v8/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroupMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "memberGroupMemberships",
                            "plural": false,
                            "selections": (v15/*: any*/),
                            "storageKey": null
                          },
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1195876ef2181471f762b1b2c6d0ecae",
    "id": null,
    "metadata": {},
    "name": "EditMemberGroupFormMutation",
    "operationKind": "mutation",
    "text": "mutation EditMemberGroupFormMutation(\n  $input: EditMemberGroupInput!\n) {\n  response: editMemberGroup(input: $input) {\n    node {\n      id\n      parentMemberGroup {\n        ...AdminGroupsListRowFragment\n        ...MemberGroupSubGroupListFragment\n        id\n      }\n      product {\n        ...ExperienceSettingsGroupsTabFragment\n        id\n      }\n      memberGroupMemberships {\n        edges {\n          node {\n            id\n            memberGroup {\n              ...MemberGroupTagFragment\n              id\n            }\n            productMembership {\n              ...useMemberGroupTagsList_ProductMembershipFragment\n              id\n            }\n            organizationMembership {\n              ...useMemberGroupTagsList_OrganizationMembershipFragment\n              id\n            }\n          }\n        }\n      }\n      ...GroupsListChildGroupRowFragment\n      ...AdminGroupsListRowFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AdminGroupsListRowFragment on MemberGroup {\n  id\n  name\n  color\n  kind\n  isSystem\n  createdAt\n  productId\n  organizationId\n  description\n  avatarURL\n  unassignedMembers {\n    totalCount\n  }\n  ...UnassignedMemberRowFragment\n  ...DeleteMemberGroupButtonFragment\n  ...CreateMemberGroupButtonFragment\n  ...EditMemberGroupButtonFragment\n  ...MemberGroupTagFragment\n  ...MemberGroupVisibilityChipFragment\n  ...MemberGroupKindChipFragment\n  childrenGroups {\n    edges {\n      node {\n        id\n        ...GroupsListChildGroupRowFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  sampleMemberships: memberGroupMemberships(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        user {\n          id\n          firstName\n          lastName\n          ...ProfileAvatarFragment\n          ...ProfileListModalListItemFragment\n        }\n      }\n    }\n  }\n}\n\nfragment CourseGroupsListFragment on Product {\n  id\n  defaultMemberGroup {\n    ...CreateMemberGroupButtonFragment\n    id\n  }\n  memberGroups(kind: custom) {\n    edges {\n      node {\n        id\n        ...CourseGroupsListItemFragment\n      }\n    }\n  }\n  ...usePermissionsFragment\n}\n\nfragment CourseGroupsListItemAvatarStackFragment on MemberGroup {\n  id\n  name\n  sampleMemberships: memberGroupMemberships(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        user {\n          id\n          firstName\n          lastName\n          ...ProfileAvatarFragment\n          ...ProfileListModalListItemFragment\n        }\n      }\n    }\n  }\n}\n\nfragment CourseGroupsListItemFragment on MemberGroup {\n  id\n  name\n  color\n  ...CourseGroupsListItemAvatarStackFragment\n  ...MemberGroupMoreActionsDropdownFragment\n  ...MemberGroupTagFragment\n}\n\nfragment CreateMemberGroupButtonFragment on MemberGroup {\n  ...CreateMemberGroupModalFragment\n}\n\nfragment CreateMemberGroupModalFragment on MemberGroup {\n  id\n}\n\nfragment DeleteMemberGroupButtonFragment on MemberGroup {\n  id\n  name\n  productId\n}\n\nfragment DeleteSubGroupButtonFragment on MemberGroup {\n  id\n  name\n  productId\n  parentMemberGroupId\n}\n\nfragment EditMemberGroupButtonFragment on MemberGroup {\n  id\n}\n\nfragment ExperienceSettingsGroupsTabFragment on Product {\n  id\n  defaultMemberGroup {\n    ...CreateMemberGroupButtonFragment\n    id\n  }\n  ...CourseGroupsListFragment\n}\n\nfragment GroupsListChildGroupRowFragment on MemberGroup {\n  id\n  kind\n  createdAt\n  ...DeleteSubGroupButtonFragment\n  ...EditMemberGroupButtonFragment\n  ...MemberGroupTagFragment\n  ...MemberGroupVisibilityChipFragment\n  ...MemberGroupKindChipFragment\n  product {\n    name\n    id\n  }\n  parentMemberGroup {\n    name\n    id\n  }\n  memberGroupMemberships {\n    totalCount\n  }\n}\n\nfragment MemberGroupKindChipFragment on MemberGroup {\n  isSystem\n}\n\nfragment MemberGroupMoreActionsDropdownFragment on MemberGroup {\n  id\n  kind\n  ...EditMemberGroupButtonFragment\n  ...DeleteSubGroupButtonFragment\n}\n\nfragment MemberGroupSubGroupListFragment on MemberGroup {\n  id\n  childrenGroups {\n    edges {\n      cursor\n      node {\n        id\n        ...MemberGroupSubGroupListRowFragment\n        ...GroupsListChildGroupRowFragment\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n\nfragment MemberGroupSubGroupListRowFragment on MemberGroup {\n  id\n  name\n  parentMemberGroup {\n    id\n    name\n  }\n  product {\n    name\n    id\n  }\n  createdAt\n  kind\n  isSystem\n  color\n  memberGroupMemberships {\n    totalCount\n    edges {\n      node {\n        id\n        userId\n        organizationMembershipId\n      }\n    }\n  }\n  ...MemberGroupTagFragment\n  ...EditMemberGroupButtonFragment\n  ...DeleteSubGroupButtonFragment\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment MemberGroupVisibilityChipFragment on MemberGroup {\n  visibility\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileListModalListItemFragment on User {\n  id\n  firstName\n  lastName\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment UnassignedCreateMemberGroupButtonFragment on MemberGroup {\n  id\n}\n\nfragment UnassignedMemberRowFragment on MemberGroup {\n  __typename\n  id\n  productId\n  ...UnassignedCreateMemberGroupButtonFragment\n  unassignedMembers {\n    totalCount\n  }\n}\n\nfragment useMemberGroupTagsList_OrganizationMembershipFragment on OrganizationMembership {\n  id\n  groupMemberships(groupKinds: [custom]) {\n    edges {\n      node {\n        id\n        productId\n        memberGroup {\n          id\n          parentMemberGroupId\n          visibility\n          ...MemberGroupTagFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useMemberGroupTagsList_ProductMembershipFragment on ProductMembership {\n  id\n  memberGroupMemberships(groupKinds: [custom]) {\n    edges {\n      node {\n        id\n        productId\n        memberGroup {\n          id\n          parentMemberGroupId\n          visibility\n          ...MemberGroupTagFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "2976755cee20f048f97cd7f61dbc1b73";

export default node;
